<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $t('global.languages_list_title', 'Languages') }} </h4>
          </b-col>

          <b-col md="auto">
            <b-button-group class="mb-3">
              <b-button variant="primary" :to="{ name: 'LanguageCreate' }">
                {{ $t('global.language_create_new') }}
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <b-table class="table-sm text-center" responsive bordered
                :fields="tableFields" :items="tableItems">
                <template v-slot:cell(is_active)="row">
                  <b-form-checkbox disabled v-model="row.item.is_active" />
                </template>
                <template v-slot:cell(options)="row">
                  <div class="flex-container options-center">
                    <router-link :to="{ name: 'LanguageUpdate', params:{ id: row.item.id }}">
                      <a><i class="mx-1 fa fa-edit fa-lg"/></a>
                    </router-link>
                    <Delete :id="row.item.id" @getData="getData"/>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator at bottom-->
            <b-col v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VT from '@/store/types';
import Delete from './LanguageDelete.vue';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      tableFields: [
        { key: 'id', label: this.$t('global.id') },
        { key: 'name', label: this.$t('global.name_language') },
        { key: 'key', label: this.$t('global.key_language') },
        { key: 'is_active', label: this.$t('global.is_active') },
        { key: 'created_at', label: this.$t('global.created_at') },
        { key: 'updated_at', label: this.$t('global.updated_at') },
        {
          key: 'options',
          label: this.$t('global.options'),
        }
      ],
      tableItems: [],
    };
  },
  components: {
    Pagination, Delete
  },
  computed: {
    ...mapGetters('Languages', [
      'languagesList'
    ]),
    listPaginator() {
      return Object.is(this.languagesList.data, undefined) ? {} : this.languagesList.data.meta;
    },
    list() {
      return this.languagesList;
    }
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        if (this.list['status'] === statuses.LOADED) {
          this.tableItems = this.list.data.data || [];
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Languages', [
      VT.LANGUAGES_LIST,
    ]),
    getData() {
      this.LANGUAGES_LIST(this.page);
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'Languages', params: { page } });
      }
    },
  }
};
</script>

<style scoped>
</style>
